module.exports = __webpack_public_path__ + "static/media/white_pomegranate.87688182.png";